import type { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useConditionStyles = makeStyles((theme: Theme) => ({
    noToolTipBox: {
        marginTop: 6,
    },
    smallBox: {
        marginRight: theme.spacing(2),
        flex: 1,
    },
    mediumBox: {
        marginRight: theme.spacing(2),
        flex: 1,
        marginBottom: 22,
    },
    largeBox: {
        flex: 1,
        marginRight: theme.spacing(2),
    },
    subFieldPadding: {
        paddingLeft: theme.spacing(2),
    },
    communBox: {
        display: "flex",
        alignItems: "flex-end",
        minWidth: "500px",
    },
    titleToolTip: {
        fontSize: 20,
    },
    containerToolTipAndText: {
        display: "flex",
        alignItems: "center",
    },
    labelBold: {
        fontWeight: "bold",
    },
    marginBottomTitle: {
        marginBottom: 8,
    },
    smallYMargin: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    label: {
        fontSize: 14,
        display: "block",
    },
    selectLabel: {
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
    },
    select: {
        minWidth: "150px",
        display: "flex",
        flexDirection: "column",
    },
    alertInfoList: {
        listStyle: "inside",
        marginLeft: theme.spacing(2),
    },
    alertInfoMin: {
        color: "red",
    },
    alertInfoMax: {
        color: "green",
    },
    flex: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: theme.spacing(2),
    },
    openDialog: {
        textDecoration: "underline",
        fontSize: "12px",
        fontWeight: "bold",
        cursor: "pointer",
    },
    thresholdDialog: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
        marginBottom: theme.spacing(2),
    },
    blueText: {
        color: theme.palette.primary.main,
    },
    thresholdDialogText: {
        marginRight: theme.spacing(4),
        fontSize: "14px",
        fontWeight: 500,
    },
    smallFont: {
        fontSize: "12px",
    },
    thresholdDialogListItemPrimary: {
        fontSize: 14,
    },
    thresholdDialogListItemSecondary: {
        color: theme.palette.textGrey.main,
        fontSize: 12,
    },
    thresholdDialogRoot: {
        margin: "4px",
    },
    capitalize: {
        textTransform: "capitalize",
    },
    fullWidth: {
        width: "100%",
    },
    adornmentColor: {
        color: "rgba(0, 0, 0, 0.38);",
    },
    cardContentContainer: {
        display: "flex",
        flexDirection: "column",
        gap: 24,
    },
    subCardContentContainer: {
        display: "flex",
        flexDirection: "column",
        gap: 16,
    },
}));
